import React from "react";
import Navitem from "./Navitem";
import { makeStyles } from '@mui/styles';
import AppBar from '@mui/material/AppBar';
import Grid from '@mui/material/Grid';
import Icon from '@mui/material/Icon';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import {globalTheme} from "../components/Theme"
import Social from "./Social";

const useStyles = makeStyles((theme) => ({
    nav: {
        margin: '10px 0px',
        width: '100%',
        
    },
    title: {
      position: 'absolute',
      right: theme.spacing(3)
    },
    root: {
      position: 'fixed',
    },
    appbar: {
      backgroundColor: 'rgb(30, 34, 43)',
      alignItems: 'center',
      flexDirection: 'column',
    },
    closeButton: {
      position: 'absolute',
      top: '0',
      right: '0',
    },
    pageTitle: {
       fontWeight: 600,
      //  margin: theme.spacing(3),
      //  [theme.breakpoints.down('xs')]: {
      //     margin: theme.spacing(1),
      // },
    }
  }), globalTheme);

export default function Navbar(props) {
  const classes = useStyles(globalTheme);

  return (
    <AppBar className={classes.appbar} position="sticky">
      <Toolbar>
        <Typography variant="h4" className={classes.pageTitle} color="primary"> TIMOTHY TAN</Typography>
      </Toolbar>
      <Social />
      <Grid 
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className={classes.nav}>
          <Navitem item="Home" tolink="/" icon={<Icon className="fa fa-home"/>}/>
          <Navitem item="Projects" tolink="/projects" icon={<Icon className="fa fa-folder"/>}/>
          {/*<Navitem item="Resume" tolink="/resume" icon={<Icon style={{width: "25px"}} className="fa fa-id-card" />}/>*/}
        </Grid>
    </AppBar>
  );
}
